import { HttpClient } from "@angular/common/http";
import { computed, Injectable, Signal, signal } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FeatureFlag } from "../../_objects/feature-flag";
import { HttpService } from "../http.service";
import { FeatureFlagContractService } from "./feature-flag.contract.service";

type FeatureFlagDict = { [featureFlagName: string]: boolean };

@Injectable({
  providedIn: "root"
})
export class FeatureFlagOnlineService extends HttpService implements FeatureFlagContractService {
  private featureFlags = signal<FeatureFlagDict>({});

  constructor(private http: HttpClient) {
    super();
    super.setHttpClient(http);
  }
  public isFlagEnabled(flagName: string): Signal<boolean> {
    return computed(() => this.featureFlags()[flagName] ?? false);
  }

  private toDictionnary(flags: FeatureFlag[]): FeatureFlagDict {
    return flags.reduce((dict, flag) => {
      dict[flag.name] = flag.isEnabled;
      return dict;
    }, {} as FeatureFlagDict);
  }

  getFeatureFlags(): Observable<FeatureFlag[]> {
    const endpoint = super.getEndpoint("featureflags");
    return this.http.get<FeatureFlag[]>(endpoint, {
      withCredentials: super.getWithCredentialsOption()
    });
  }

  public fetchAndUpdate(): Observable<void> {
    return this.getFeatureFlags().pipe(map((flags) => this.featureFlags.set(this.toDictionnary(flags))));
  }
}
